export default function CallToAction() {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-100 to-orange-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          Need to Ship Multiple Vehicles?
        </h2>
        <p className="text-xl text-gray-700 mb-8">
          Contact our fleet specialists for volume discounts
        </p>
        <a
          href="tel:8001234567"
          className="inline-flex items-center bg-gray-900 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-800 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
        >
          Contact Fleet Team
          <i className="ri-arrow-right-line ml-2"></i>
        </a>
        <p className="mt-6 text-gray-600">
          Or call us at{' '}
          <a
            href="tel:3058719862"
            className="inline-flex items-center bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Call (305) 871-9862
          </a>
        </p>
      </div>
    </section>
  );
}
